// extracted by mini-css-extract-plugin
export default {"wrapper":"eRYUAWR9jxOePu5EcNDl","photo":"PGocAUfIuk8PQ5YrIy8x","title":"HcdqHLAfV9oYggo5D0rx","text":"rnLUeSSVzOBlqeG0cKPr"};